import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { setCurrentStep, setBuyerPersonalData, setCollaborationApproval } from '../OwnershipTransferBuyerSlice';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import TextInput from '../../../Shared/TextInput/TextInput';
import { OwnershipTransferPrivateBuyerStep, ServiceType, CollapseLabelCheckBox } from '../Constant/Constant';
import { validateInput, TextInputEnum } from '../../../../utilities/validation/InputValidation';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import ThirdParty from '../../../Shared/ThirdParty/ThirdParty';
import { buildUrlAndOpenWindow } from '../../../../utilities/StringHelpers/StringHelpers';
import Config from 'app/Config';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { styledNumber } from '../../../../utilities/StringHelpers/TitleHelpers';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'
import CheckboxCollapseLabel from 'app/Components/Shared/CheckboxCollapseLabel/CheckboxCollapseLabel';

const CustomerData = (props) => {
    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            dwhGeneralReport({
                data: { ...props.data, userDetails: props.userDetails },
                actionType: DwhActionType.DetailPage,
                messageText: DWHMessageText.DetailPageDisplayed,
                status: DWHStatus.Ongoing
            });
        }
    }, []);

    const [errors, setErrors] = useState({ firstName: '', lastName: '', email: '' });
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [errorText, setErrorText] = useState('');
    const [checkbox, setCheckbox] = useState([
        {
            id: 0,
            title: (
                <div className='checkboxes-title'>
                    קראתי ואני מסכימ/ה ל
                    <a href='#' className='link' onClick={() => buildUrlAndOpenWindow(props.data.selectedPricePlan.programDetailsLink)}>
                        עיקרי פרטי התכנית
                    </a>
                    ,ל
                    <a href='#' className='link' onClick={() => buildUrlAndOpenWindow(props.data.selectedPricePlan.connectionAgreementLink)}>
                        הסכם ההתקשרות
                    </a>
                    ו
                    <a href='#' className='link' onClick={() => Config.cooperationTermsLink ? buildUrlAndOpenWindow(Config.cooperationTermsLink) : null}>
                        לתנאים הכלליים*
                    </a>
                </div >
            ),
            checked: false,
        }, {
            id: 1,
            title: (
                <div className='checkboxes-title'>
                    <CheckboxCollapseLabel
                        defaultText={props.data.serviceType == ServiceType.StationaryLine ? CollapseLabelCheckBox.stationary.defaultText : CollapseLabelCheckBox.cellular.defaultText}
                        extendedText={props.data.serviceType == ServiceType.StationaryLine ? CollapseLabelCheckBox.stationary.extendedText : CollapseLabelCheckBox.cellular.extendedText} />
                </div>
            ),
            checked: false,
        },
        {
            id: 2,
            title: (
                <div className='checkboxes-title'>
                    <ThirdParty />
                </div>
            ),
            checked: false,
        },
    ]);


    function nextStep() {
        if (!validateRequiredData()) {
            setShowErrorMsg(true);
        } else {
            dwhGeneralReport({
                data: { ...props.data, userDetails: props.userDetails },
                actionType: DwhActionType.DetailPage,
                messageText: DWHMessageText.DetailPageButtonClicked,
                status: DWHStatus.Ongoing
            });
            props.setCurrentStep(OwnershipTransferPrivateBuyerStep.CustomerAddress)
        }
    }

    function onCheck(index) {
        let temp = [...checkbox];
        temp[index].checked = !temp[index].checked;
        setCheckbox(temp);
        setShowErrorMsg(false);
        if (index == 2) {
            props.setCollaborationApproval(temp[index].checked);
        }
    }

    function validateRequiredData() {
        if (
            Object.values(errors).some((value) => value !== '') ||
            Object.values(props.data.buyerPersonalData).some((value) => value.trim() === '')
        ) {
            setErrorText('כדי להמשיך יש למלא את כל שדות החובה ');
            return false;
        } else if ((props.data.serviceType == ServiceType.Cellular && !checkbox.find((ch) => ch.id == 0).checked) || !checkbox.find((ch) => ch.id == 1).checked) {
            setErrorText('חובה לאשר את העברת הבעלות והתנאים הכלליים');
        } else {
            setErrorText('');
            return true;
        }
    }

    function getTitle() {
        if (props.data.serviceType == ServiceType.Cellular) {
            return ` פרטי מנוי מספר ${styledNumber(props.data.transferSubscriberNumber)}`;
        }
        else {
            return ` פרטי מנוי  ${props.data.transferProductName}`;

        }
    }

    return (
        <div className='ownership-transfer-form ownership-transfer-step'>
            <div className='l-title center' dangerouslySetInnerHTML={{ __html: getTitle() }} />
            <div className='m-title center'> יש למלא את הפרטים החסרים</div>
            <div>
                <TextInput
                    value={props.userDetails.magicLinkParameters?.idNumber}
                    id='idNumber'
                    placeholder={'ת.ז'}
                    pattern='[0-9]*'
                    maxLength='9'
                    onChange={(e) => {
                        null
                    }}
                    required='required'
                    disabled={true}
                />
                <TextInput
                    value={props.data.buyerPersonalData.firstName}
                    error={errors.firstName}
                    id='firstName'
                    placeholder={'שם פרטי'}
                    onChange={(e) => {
                        setErrors({ ...errors, firstName: validateInput(e.target.value, TextInputEnum.FirstName) });
                        props.setBuyerPersonalData({ firstName: e.target.value });
                        setShowErrorMsg(false);
                    }}
                    required='required'
                />
                <TextInput
                    value={props.data.buyerPersonalData.lastName}
                    error={errors.lastName}
                    id='lastName'
                    placeholder={'שם משפחה'}
                    onChange={(e) => {
                        setErrors({ ...errors, lastName: validateInput(e.target.value, TextInputEnum.LastName) });
                        props.setBuyerPersonalData({ lastName: e.target.value });
                        setShowErrorMsg(false);
                    }}
                    required='required'
                />
            </div>
            <div className='customer-email'>
                <div className='customer-email-title semi'>כתובת מייל ראשית לדיוור ומידע</div>
                <TextInput
                    value={props.data.buyerPersonalData.email}
                    error={errors.email}
                    id='mail'
                    placeholder={'מייל'}
                    onChange={(e) => {
                        setErrors({ ...errors, email: validateInput(e.target.value, TextInputEnum.Mail) });
                        props.setBuyerPersonalData({ email: e.target.value });
                        setShowErrorMsg(false);
                    }}
                    required='required'
                />
                <div className='customer-email-text text-under-input'>
                    {Config.primaryEmailText}{' '}
                    <a href='#' className='link' onClick={() => buildUrlAndOpenWindow(Config.primaryEmailMoreInfoUrl)} target='_blank'>
                        {Config.primaryEmailMoreInfoText}
                    </a>{' '}
                </div>
            </div>
            <div className='checkboxes'>
                {checkbox.map((item, index) => {
                    if (props.data.serviceType == ServiceType.StationaryLine && item.id == 0) return null;
                    if (props.data.needsToSignCollaborationApproval === false && item.id == 2) return null;
                    else
                        return (
                            <div className='transfer-checkbox' key={index}>
                                <CheckBox
                                    id={index}
                                    onCheck={() => onCheck(index)}
                                    onUncheck={() => onCheck(index)}
                                    checked={item.checked}
                                    label={item.title}
                                />
                            </div>
                        );
                })}
            </div>

            <div className='continue-button'>
                {showErrorMsg && <div className='error center'>{errorText}</div>}
                <BtnSubmit onclick={nextStep} text={'אפשר להמשיך'} />
            </div>

        </div>
    );
};

const mapStateToProps = (state) => ({
    data: state.OwnershipTransferPrivateBuyer,
    userDetails: state.authentication.loginData,
});

const mapDispatchToProps = {
    setBuyerPersonalData,
    setCurrentStep,
    setCollaborationApproval,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerData);
